import { ButtonGroup, IconButton } from '@chakra-ui/react';
import { IconLayoutHalf } from 'central-icons/IconLayoutHalf';
import { IconLayoutTopbar } from 'central-icons/IconLayoutTopbar';
import classNames from 'classnames';

import styles from './ViewModeToggle.module.css';

interface ViewModeToggleProps {
  viewMode: 'list' | 'card';
  onViewModeChange: (mode: 'list' | 'card') => void;
}

export const ViewModeToggle = ({
  viewMode,
  onViewModeChange,
}: ViewModeToggleProps) => {
  return (
    <div className={styles.container}>
      <div
        className={classNames(
          styles.slider,
          viewMode === 'list' ? styles.sliderList : styles.sliderCard
        )}
      />
      <ButtonGroup size="sm" isAttached position="relative">
        <IconButton
          aria-label="List View"
          icon={<IconLayoutTopbar size={16} />}
          onClick={() => onViewModeChange('list')}
          bg="transparent"
          color={viewMode === 'list' ? 'gray.700' : 'gray.400'}
          _hover={{
            bg: 'transparent',
            color: 'gray.600',
          }}
          height="22px"
          width="24px"
          minWidth="24px"
          transition="color 0.2s"
          data-testid="td-list-view-toggle"
        />
        <IconButton
          aria-label="Card View"
          icon={<IconLayoutHalf size={16} strokeWidth="0px" />}
          onClick={() => onViewModeChange('card')}
          bg="transparent"
          color={viewMode === 'card' ? 'gray.700' : 'gray.400'}
          _hover={{
            bg: 'transparent',
            color: 'gray.600',
          }}
          height="22px"
          width="24px"
          minWidth="24px"
          transition="color 0.2s"
          data-testid="td-card-view-toggle"
        />
      </ButtonGroup>
    </div>
  );
};
